import {
  BMComponentsType,
  BMPrimitives,
  BMRadioButton,
  BMText,
  useBMTheme,
} from "@traveloka/district-bloom";
import { Platform, StyleSheet } from "react-native";

import HighlightText from "../../HighlightText/HighlightText";
import BMView from "../../View/BMView";
import { BMDropdownOptionItemProps } from "../types";

export default function BMDropdownOptionItem({
  label,
  query = "",
  isSelected,
  options = {},
  isMobile = false,
  isRadio = false,
}: BMDropdownOptionItemProps) {
  const { caption, trailingText, LeadingIcon } = options;
  const { TrailingIcon } =
    "TrailingIcon" in options ? options : { TrailingIcon: null };

  const { BMComponents } = useBMTheme();
  const styles = createStyles(BMComponents, isMobile, isSelected);

  const variant = isMobile || !isSelected ? "uiLarge" : "uiLargeEm";

  return (
    <BMView row style={styles.container} justify="between" align="center">
      <BMView flex spacing="md" justify="center">
        {LeadingIcon && (
          <BMView style={styles.leadingContainer}>
            <LeadingIcon
              width={24}
              height={24}
              accentColor={BMComponents.BMStyleIconInkPrimary}
            />
          </BMView>
        )}
        <BMView spacing="xs">
          <BMView style={styles.marginTopXXS}>
            <BMText numberOfLines={1} ellipsizeMode="tail" style={styles.label}>
              <HighlightText
                keyword={query}
                searchedText={label}
                defaultTextProps={{
                  variant: variant,
                  ink: "BMStyleTextInkPrimary",
                }}
                highlightTextProps={{
                  variant: variant,
                  ink: "BMStyleTextInkAction",
                }}
              />
            </BMText>
          </BMView>
          {caption && (
            <BMText variant="uiSmall" numberOfLines={2} ellipsizeMode="tail">
              {caption}
            </BMText>
          )}
        </BMView>
      </BMView>
      {!isRadio && (TrailingIcon || trailingText) && (
        <BMView style={styles.trailingContainer}>
          {TrailingIcon && (
            <TrailingIcon
              width={24}
              height={24}
              accentColor={BMComponents.BMStyleIconInkPrimary}
            />
          )}
          {trailingText && (
            <BMText variant="paragraphSmall">{trailingText}</BMText>
          )}
        </BMView>
      )}
      {isRadio && (
        <BMView pointerEvents="none" style={styles.marginRightRadio}>
          <BMRadioButton value={isSelected} />
        </BMView>
      )}
    </BMView>
  );
}

function createStyles(
  BMComponents: BMComponentsType,
  isMobile: boolean,
  isSelected: boolean
) {
  return StyleSheet.create({
    container: {
      paddingVertical: BMPrimitives.BMSize.md,
      ...(isMobile
        ? { paddingHorizontal: BMPrimitives.BMSize.lg }
        : { paddingHorizontal: BMPrimitives.BMSize.xl }),
      ...(isSelected
        ? { backgroundColor: BMComponents.BMStyleSurfaceBgcolorHighlight }
        : {}),
    },
    leadingContainer: {
      marginRight: BMPrimitives.BMSize.sm,
    },
    trailingContainer: {
      alignItems: "flex-end",
      marginLeft: BMPrimitives.BMSize.sm,
    },
    marginTopXXS: {
      marginTop: BMPrimitives.BMSize.xs / 2,
    },
    marginRightRadio: {
      marginRight: Platform.OS !== "web" ? BMPrimitives.BMSize.xl : 0,
    },
    label: { flexWrap: "wrap", flexDirection: "row" },
  });
}
